import React from "react";

import "./styles.less";
import { useTranslation } from "react-i18next";
import { Title } from "../../components/Title";

export const AdContent = () => {
  const { t } = useTranslation();

  return (
    <div>
      <section>
        <div className="ad-content">
          <div className="inner">
            <div className="content">
              <Title title={t("solution.buildAd.intro.item1.title")}></Title>
              <div className="descriptWarp">
                <div className="ad-text">{t("solution.buildAd.intro.item1.descript")}</div>
                <div className="ad-img">
                  <img src={"//files.authing.co/authing-website/solution-ad-problem.png"} alt="authing ad problem" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="ad-content" style={{ background: "#fafafa" }}>
          <div className="inner">
            <div className="content">
              <Title title={t("solution.buildAd.intro.item2.title")}></Title>
              <div className="descriptWarp">
                <div className="ad-img">
                  <img src={"//files.authing.co/authing-website/solution-ad-process.png"} alt="authing ad intro" />
                </div>
                <div className="ad-text">{t("solution.buildAd.intro.item2.descript")}</div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="ad-content">
          <div className="inner">
            <div className="content">
              <Title title={t("solution.buildAd.intro.item3.title")}></Title>
              <div className="descriptWarp">
                <div className="ad-text">{t("solution.buildAd.intro.item3.descript")}</div>
                <div className="ad-img">
                  <img src={"//files.authing.co/authing-website/solution-ad-security.png"} alt="authing ad intro" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="ad-content" style={{ background: "#fafafa" }}>
          <div className="inner">
            <div className="content">
              <Title title={t("solution.buildAd.intro.item4.title")}></Title>
              <div className="descriptWarp">
                <div className="ad-img">
                  <img src={"//files.authing.co/authing-website/solution-ad-value.png"} alt="authing ad intro" />
                </div>
                <div className="ad-text">{t("solution.buildAd.intro.item4.descript")}</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
